import { defineStore } from 'pinia'
import { ref } from 'vue'
import { shopUpdate, shopInfoById } from '@/api/shops'
import type { ShopEntity } from '@/types/payment-gateway-config'
import type { ShopAPI } from '@/api/typeings/shops'

export const useShopStore = defineStore('shop', () => {
  interface ShopDetail {
    id: number
    shopName: string
    shopifyId: string
    [key: string]: any
  }
  const shopId = ref('')
  const shopState = ref(false)
  const shopStateMsg = ref('')
  const shopDetail = ref<ShopDetail>({
    id: 0,
    shopName: '',
    shopifyId: '',
  })

  const originalData = ref<ShopAPI.ShopDto>({} as ShopAPI.ShopDto)

  // actions
  const fetchShopDetail = async () => {
    try {
      if (!shopId.value) {
        throw new Error('Missing shopId')
      }
      // 获取店铺信息
      const data = await shopInfoById(shopId.value || '')
      // 保存原始数据
      originalData.value = data
      // 转换API响应以匹配ShopEntity类型
      shopDetail.value = {
        ...data,
        id: data.id?.toString(),
        merchant: data.merchant,
      }


      // 从paypalApi中获取配置信息 paypalApi是Json字符串
      if (data.paypalApi) {
        // const paypalApi = JSON.parse(data.paypalApi)
        shopDetail.value = {
          ...shopDetail.value,
          // ...paypalApi,
        }
      }

      return data
    } catch (error: any) {
      console.error('Error fetching shop detail:', error)
      throw error
    }
  }

  const updateShop = async (params: ShopAPI.ShopDto) => {
    try {
      if (shopDetail.value?.id) {
        const result = await shopUpdate({ id: Number(shopDetail.value.id) }, params, {
          successMsg: '更新成功',
        })
        if (result.success) {
          await fetchShopDetail()
        }
        return result
      }
    } catch (error: any) {
      console.error('Error updating shop:', error)
      throw error
    }
  }

  const setShopDetail = (newDetail: Partial<ShopEntity>) => {
    shopDetail.value = {
      ...shopDetail.value,
      ...newDetail,
    }
  }

  const setShopId = (id: string) => {
    shopId.value = id
  }

  const setShopState = (state: boolean, msg?: string) => {
    shopState.value = state
    shopStateMsg.value = msg || ''
  }

  return {
    // state
    shopId,
    setShopId,
    shopDetail,
    originalData,
    shopState,
    shopStateMsg,
    setShopState,
    // actions
    fetchShopDetail,
    updateShop,
    setShopDetail,
  }
}, {
  persist: true
})
